class KovaUtil {

  static formatPhoneNumber(phoneNumber: string) {
    let cleanPhoneNumber = "";
    for (let i = 0; i < phoneNumber.length; i++) {
      const number = Number.parseInt(phoneNumber[i], 10)
      if (!Number.isNaN(number)) {
        cleanPhoneNumber += phoneNumber[i];
      }
    }

    let numberlen = cleanPhoneNumber.length;
    phoneNumber = cleanPhoneNumber.slice(0, Math.min(3, numberlen));
    if (numberlen > 3) {
      phoneNumber = "(" + phoneNumber + ") ";
      phoneNumber += cleanPhoneNumber.slice(3, Math.min(6, numberlen));
      if (numberlen > 6) {
        phoneNumber += "-";
        phoneNumber += cleanPhoneNumber.slice(6, Math.min(10, numberlen));
      }
    }
    return phoneNumber;
  };
}
export default KovaUtil;